import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle1, Body1 } from '@src/elements/typography/typography'

import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { Modal } from '@src/elements/modal/modal'
import { Button } from '@src/elements/button/button'
import { Spacer } from '@src/elements/spacer/spacer'
import Member from '@src/data/member'
import TrainingPlan from '@src/data/training-plan'
import { TrainingPlanService } from '@src/service/training-plan'
import { convertToLocalDate } from '@src/util/date-format'
import SessionManager from '@src/lib/session_manager'
import { MemberTrainingPlanDTO } from '@src/routes/content/components/training-plan-builder/save-plan'

import './intersections-popup.sass'

@Component
export class IntersectionsPopup extends ConfirmModal {

  @Prop({ required: true })
  private member: Member

  @Prop({ required: true })
  private intersections: TrainingPlan[]

  @Prop({ required: false })
  private overwritingTrainingPlan: MemberTrainingPlanDTO

  @Prop({ required: false, default: false })
  private openInNewTab: boolean

  constructor () {
    super()
  }

  overwrite () {
    new TrainingPlanService().overwriteExistingTrainingPlans(this.intersections, this.overwritingTrainingPlan, this.showAssignSuccessfulMessage, this.$store)
  }

  goToUpcomingTPS () {
    let path = SessionManager.Instance.isManager() ? `/trainers/platform/members/${this.member.id}/training` : `/members/${this.member.id}/training`
    this.closeCallback(false)
    const routeData = this.$router.resolve({ path: path, query: { section: 'upcoming_plans' } })
    this.openInNewTab ? window.open(routeData.href, '_blank') : this.$router.push(routeData.location)
  }

  showAssignSuccessfulMessage (successfulAssign: boolean) {
    this.closeCallback(successfulAssign)
  }

  render (h: CreateElement) {
    const intersections = this.intersections.map(intersectionTrainingPlan => {
      return <Body1>
        <b>{intersectionTrainingPlan.name}</b> {convertToLocalDate(intersectionTrainingPlan.startDate)} - {convertToLocalDate(intersectionTrainingPlan.endDate)}
      </Body1>
    })

    return <Modal show={this.show} title={this.$t('PAGE.MEMBERS.TRAINING.TRAINING_PLAN_OVERLAP.TITLE')} closeCallback={this.closeCallback} cssClass={'popup intersections-popup'}>
      <div class='message'>
        {this.$t('PAGE.MEMBERS.TRAINING.TRAINING_PLAN_OVERLAP.BODY')}
        <Spacer />
        <Spacer />
        <Subtitle1 class='list-header'>{this.$t('PAGE.MEMBERS.TRAINING.OVERLAPPING_PLANS')}:</Subtitle1>
        <div class='intersections-list'>{intersections}</div>
      </div>

      <div slot='footer' class='btn-row'>
        <Button type='outline' class='overwrite-btn no' align='right' label={this.$t('PAGE.MEMBERS.TRAINING.OVERWRITE_INTERSECTION')} click={this.overwrite} />
        <Button type='elevated' class='navigate-btn no' align='right' label={this.$t('PAGE.MEMBERS.TRAINING.GO_TO_UPCOMING_TPS')} click={this.goToUpcomingTPS} />
      </div>
    </Modal>
  }
}
